export default {
  VerifyModal: {
    title: "Verifica tu cuenta",
    send: "Enviar para verificación",
    step1: {
      reason:
        "El servicio está diseñado exclusivamente para profesionales médicos, por lo que el acceso a algunas funciones está restringido solo a usuarios verificados. Esto permite:",
      reasons: {
        1: "Excluir el acceso a pacientes y personas ajenas",
        2: "Garantizar una comunidad profesional para el intercambio de conocimientos y experiencias",
        3: "Cumplir con la ética médica y los estándares de manejo de datos",
      },
      end: "Valoramos tu seguridad y privacidad. Toda la información se utiliza únicamente para verificar tu estatus y se elimina después de finalizar el proceso.",
      status: "Estatus",
      statuses: {
        doctor: "Médico",
        student: "Estudiante",
        ordinator: "Residente",
      },
    },
    step2: {
      agenda:
        "Todos los datos proporcionados están protegidos y se utilizan exclusivamente para verificar tu estatus.",
      chooseVerifyWay: "Elige una forma de verificación",
      ways: {
        1: "Diploma, certificado o acreditación",
        2: "Enlace a tu perfil verificado en un agregador médico (Prodoctorov, DocDoc, etc.)",
        3: "Enlace a tu perfil en el sitio web de la clínica",
        4: "Sube tu diploma de estudios médicos",
        5: "Sube tu credencial de estudiante de universidad médica",
      },
      selectFile: "Selecciona un archivo",
      sendToCheck: "Enviar para verificación",
      pasteLink: "Pega el enlace",
      notAllowedFile: "Solo se permiten archivos PDF e imágenes.",
      noMoreFiles: "Número máximo de archivos: ",
    },
    step3: {
      title: "Documento enviado para verificación",
      text1_1:
        "Revisaremos tus datos y luego recibirás una notificación al correo ",
      text1_2: "",
      text2: "La verificación toma un día hábil.",
    },
  },
};
